import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMaquinas } from "../../store/actions/maquinas";
import { BuscarMaquina } from "./BuscarMaquina";
import { ListaMaquinas } from "./ListaMaquinas";
import { ErrorMessage } from "../../components/ErrorMessage";

import Grid from "@material-ui/core/Grid";
import { NuevaMaquina } from "./NuevaMaquina";

export const Maquinas = () => {
  // const [, dispatch] = useContext(MaquinasContext);
  const dispatch = useDispatch();
  const pageSize = useSelector((state) => state.maquinas.pageSize);
  const error = useSelector((state) => state.maquinas.error);
  const showModal = useSelector((state) => state.maquinas.showModal);

  useEffect(() => {
    dispatch(
      getMaquinas({
        pageSize,
        page: 1,
        buscando: true,
        dataBuscar: { estatus: "activo" },
      })
    );
  }, [dispatch, pageSize]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <BuscarMaquina />
      </Grid>
      <Grid item xs={12}>
        {error && !showModal ? (
          <ErrorMessage module="maquinas" />
        ) : (
          <ListaMaquinas />
        )}
      </Grid>
      {showModal && <NuevaMaquina />}
    </Grid>
  );
};
